import { render, staticRenderFns } from "./add_diction.vue?vue&type=template&id=45e3d5f4&scoped=true&"
import script from "./add_diction.vue?vue&type=script&lang=js&"
export * from "./add_diction.vue?vue&type=script&lang=js&"
import style0 from "./add_diction.vue?vue&type=style&index=0&id=45e3d5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3d5f4",
  null
  
)

export default component.exports